module.exports = __webpack_public_path__ + "static/media/personal-website.58b1b2ba.jpg";